import { Component, NgZone, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.css']
})
export class AssetComponent implements OnInit {

  userCred: any
  cid: any;
  todayDate: any = "";
  isLoading: boolean = false;
  count: any = 0;
  objectInfoList: any = [];
  singleObjectInfo: any = [];
  singleObjectTemplateData: any = [];
  objectInfoListFilter: any = [];
  objectTemplateList: any = [];

  isLockAll: boolean = false;
  isUnLockAll: boolean = false;
  isShowLock: boolean = false;
  showFilter: boolean = false;
  searchFilter: any = "";

  selectedFilter: any = ""

  modelChecked = false;
  modelFilter = "";

  locationChecked = false;
  locationFilter = "";

  lockChecked = false;
  lockFilter = "";

  makeChecked = false;
  makeFilter = "";

  typeChecked = false;
  typeFilter = "";

  serialNumberChecked = false;
  serialNumberFilter = "";

  objectConditionChecked = false;
  objectConditionFilter = "";

  branchChecked = false;
  branchFilter = "";

  departmentChecked = false;
  departmentFilter = "";

  groupChecked = false;
  groupFilter = "";
  first: number = 1;
  page: number = 0;
  tableSize: any = 10

  objectInfoId: any = 0;
  recordId: any = "";
  recordName: any = "";

  assetLock: any = []
  isLatLng: boolean = false;

  addForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {

    const now = new Date();
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);


    this.todayDate = tomorrow.toISOString().split('T')[0];
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectInfo()
    this.getAllObjectTemplate()
    // this.getAllLocation()
    // this.getAllBranch()
    // this.getAllUomMaster()
    // this.getAllGroupList()
    // this.getAllTypeList()
    // this.getAllObjectCategory()
    // this.getAllAssetDepreciationMethod()
    // this.getAllDepartment_info()
    // this.getAllAssetStatus()



    this.addForm = this.fb.group({
      objectTemplateId: [],
      description: [''],
      name: [''],
      type: [''],
      group: [''],
      make: [''],
      model: [''],
      originalCost: [''],
      currentCost: [''],
      objectCondition: ['Good'],
      conditionModifiedBy: this.fb.array(['']),

      area: this.fb.array([this.createLatLng()]),
      approvalInfos: this.fb.array([this.createApprovalInfo()]),
      icon: [''],
      objectStatus: [''],
      objectStatusColor: [''],
      objectColorCode: [''],
      givenName: [''],
      serialNumber: [''],
      acquisitionDate: [''],
      salvageValue: [0],
      depreciationMethod: [0],
      depreciationMethodName: [''],
      assetLifeNumber: [0],
      branch: [''],
      country: [''],
      provinceOrState: [''],

      addDeleteIdsObjectInfo: this.fb.group({
        assetIds: this.fb.array([0]),
        add: [true],
        parentIds: [true]
      }),

      district: [''],
      zone: [''],
      postalCode: [''],
      city: [''],
      branchId: [0],
      parentAssetId: this.fb.array([0]),
      childAssetId: this.fb.array([0]),
      department: [''],
      location: [''],
      putToUseDate: [''],
      assetStatus: [''],

      images: this.fb.array(['']),
      imagesWithDetails: this.fb.array([]),
      tags: this.fb.array(['']),

      lat: [0],
      lng: [0],
      level: [0],
      assetMonitoring: [true],
      multiLatLng: [true],

      repairInfos: this.fb.array([]),
      givenRepair: [true],
      internal: [true],

      serialNumberCheckBox: [true],
      branchCheckBox: [true],
      departmentCheckBox: [true],
      locationCheckBox: [true],
      makeCheckBox: [true],
      modelCheckBox: [true],
      originalCostCheckBox: [true],
      currentCostCheckBox: [true],
      depreciationCheckbox: [true],
      performance: [true],
      warranty: [true],
      lock: [true],
      purchase: [true],
      parentAssetIdFlag: [true],
      quantityCheckBox: [true],
      uom: [true],
      deploy: [true],
      stockPointStatus: [true],
      purchaseInfo: this.fb.array([this.createKeyValue()]),
      warrantyInfo: this.fb.array([this.createKeyValue()]),

      assetPerformance: this.fb.group({
        timeSpan: [''],
        expectedOutput: [''],
        uom: ['']
      }),

      routeId: [0],
      assetMonitoringFrequency: [0],
      assetMonitoringTimeSpan: [0],

      subGroups: this.fb.array([this.createSubGroup()]),
      nameValue: this.fb.array([this.createNameValue()]),
      connectionDetails: this.fb.array([this.createKeyValue()]),
      assetHealth: this.fb.array([this.createKeyValue()]),
      performanceMatrix: this.fb.array([this.createPerformanceMatrix()]),
      asset_Category: ['']
    });


    this.addForm.get('objectTemplateId')?.valueChanges.subscribe((objectTemplateId: string) => {
      console.log('Form changed:', objectTemplateId);
      this.getObjectTemplateById(objectTemplateId)

    });


  }


  // ---------- Helper creators for nested form groups ----------
  createLatLng(): FormGroup {
    return this.fb.group({
      lat: [''],
      lng: ['']
    });
  }

  createApprovalInfo(): FormGroup {
    return this.fb.group({
      userName: [''],
      tranDate: [''],
      tranStatus: [''],
      userId: ['']
    });
  }

  createImageDetails(): FormGroup {
    return this.fb.group({
      image: [''],
      name: [''],
      type: ['']
    });
  }

  createRepairInfo(): FormGroup {
    return this.fb.group({
      userName: [''],
      repairGivenTo: [''],
      repairGivenDate: [''],
      repairExpectedEndDate: [''],
      repairCost: [''],
      phNo: [''],
      emailId: [''],
      lat: [''],
      lng: [''],
      description: ['']
    });
  }

  createKeyValue(): FormGroup {
    return this.fb.group({
      key: [''],
      value: ['']
    });
  }

  createNameValue(): FormGroup {
    return this.fb.group({
      key: [''],
      value: [''],
      boxType: [''],
      isMandatory: [true],
      keyValue: this.fb.array([''])
    });
  }

  createSubGroup(): FormGroup {
    return this.fb.group({
      seqNo: [0],
      name: [''],
      nameValue: this.fb.array([this.createNameValue()])
    });
  }

  createPerformanceMatrix(): FormGroup {
    return this.fb.group({
      key: [''],
      value: [''],
      keyValue: this.fb.array([this.createKeyValue()])
    });
  }

  /** --- purchaseInfo --- */
  get warrantyInfo(): FormArray {
    return this.addForm.get('warrantyInfo') as FormArray;
  }

  addWarrantyInfo() {
    this.warrantyInfo.push(this.createKeyValue());
  }

  removeWarrantyInfo(index: number) {
    this.warrantyInfo.removeAt(index);
  }

  /** --- purchaseInfo --- */
  get purchaseInfo(): FormArray {
    return this.addForm.get('purchaseInfo') as FormArray;
  }

  addPurchaseInfo() {
    this.purchaseInfo.push(this.createKeyValue());
  }

  removePurchaseInfo(index: number) {
    this.purchaseInfo.removeAt(index);
  }

  // ---------- Submit ----------
  onSubmit() {
    console.log('Form Value:', this.addForm.value);
  }




  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }

  toggleFilter(){
    this.showFilter = !this.showFilter
  }

  refreshAll(){
    this.page = 1
    this.first = 0
    this.showFilter = false
    this.searchFilter = ""
  }

  selectAssetForLock(objectInfoId: any){
    this.assetLock.push(objectInfoId)
  }

  getAllObjectInfo(){
    this.isLoading = true
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        this.objectInfoList = response.response
        this.objectInfoListFilter = response.response
        this.count = response.response.length
        this.isLoading = false
      },
      (error:any)=>{
        this.isLoading = false
        console.log(error)
      }
    )
  }

  getObjectInfoById(objectInfoId: any){
    this.isLatLng = false
    this.objectInfoId = objectInfoId
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response:any)=>{
        this.singleObjectInfo = []
        this.singleObjectInfo.push(response.response)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  loadData(){
    if(this.searchFilter != ""){
      this.getObjectInfoByWildSearch()
    }else if(this.selectedFilter != ""){
      this.applyFilter()
    }else{
      this.getAllObjectInfo()
    }
  }


  bulkUpdateObjectInfoLocking(locking: any){

    let lockingFiles: any = []
    for(let list of this.objectInfoList){
      if(list.lock == locking){
        let obj = {
          "version": 0,
          "isActive": true,
          "description": "",
          "objectInfoId": list.objectInfoId,
          "locking": locking,
          "cid": list.cid
        }
        lockingFiles.push(obj)
      }
    }

    if(lockingFiles.length == 0){
      return
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "lockingFiles": lockingFiles
    }

    console.log(body)
    this.generic_service.updateObjectInfoLocking(body).subscribe(
      (response:any) => {
        this.loadData()
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
      }
    )
  }

  getObjectInfoByWildSearch(){
    this.isShowLock = false
    this.isLockAll = false
    this.isUnLockAll = false
    this.showFilter = false

    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getObjectInfoByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  applyFilter() {
    this.isShowLock = false
    this.isLockAll = false
    this.isUnLockAll = false

    if (this.modelChecked) {
      this.getAllModelByAndCid(this.modelFilter);
    }

    if (this.makeChecked) {
      this.getAllMakeByAndCid(this.makeFilter);
    }

    if (this.typeChecked) {
      this.getAllByType(this.typeFilter);
    }

    if (this.serialNumberChecked) {
      this.getAllBySerialNumberAndCid(this.serialNumberFilter);
    }

    if (this.objectConditionChecked) {
      this.getAllByObjectConditionAndCid(this.objectConditionFilter);
    }

    if (this.branchChecked) {
      this.getAllByBranchAndCid(this.branchFilter);
    }

    if (this.departmentChecked) {
      this.getAllByDepartmentAndCid(this.departmentFilter);
    }

    if (this.groupChecked) {
      this.getAllByGroup(this.groupFilter);
    }

    if (this.locationChecked) {
      this.getAllByLocationAndCid(this.locationFilter);
    }

    if (this.lockChecked) {
      this.getAllObjectsByLockAndCid(this.lockFilter);
    }
  }

  getAllModelByAndCid(model: any) {
    this.generic_service.getAllModelByAndCid(model).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return
        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllMakeByAndCid(make: any) {
    this.generic_service.getAllMakeByAndCid(make).subscribe(
      (res: any) => {
        console.log('Make Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Make Error:', err);
      }
    );
  }

  getAllObjectsByLockAndCid(lock: any){
    this.generic_service.getAllObjectsByLockAndCid(lock).subscribe(
      (res: any) => {
        console.log('lock Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return
        }

        if(lock){
          this.isUnLockAll = true
          this.isLockAll = false
          this.isShowLock = true
        }else{
          this.isLockAll = true
          this.isUnLockAll = false
          this.isShowLock = true
        }

        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Error:', err);
      }
    );
  }

  getAllByLocationAndCid(location: any){
    this.generic_service.getAllByLocationAndCid(location).subscribe(
      (res: any) => {
        console.log('Location Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  getAllBySerialNumberAndCid(serialNumber: any) {
    this.generic_service.getAllBySerialNumberAndCid(serialNumber).subscribe(
      (res: any) => {
        console.log('Serial Number Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  getAllByObjectConditionAndCid(objectCondition: any) {
    this.generic_service.getAllByObjectConditionAndCid(objectCondition).subscribe(
      (res: any) => {
        console.log('Object Condition Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Object Condition Error:', err);
      }
    );
  }

  getAllByGroup(group: any) {
    this.generic_service.getAllByGroup(group).subscribe(
      (res: any) => {
        console.log('Group Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Group Error:', err);
      }
    );
  }

  getAllObjectInfoByGroupAndType(group: any, type: any) {
    this.generic_service.getAllObjectInfoByGroupAndType(group, type).subscribe(
      (res: any) => {
        console.log('Group and Type Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Group and Type Error:', err);
      }
    );
  }

  getAllByBranchAndCid(branch: any) {
    this.generic_service.getAllByBranchAndCid(branch).subscribe(
      (res: any) => {
        console.log('Branch Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Branch Error:', err);
      }
    );
  }

  getAllByDepartmentAndCid(department: any) {
    this.generic_service.getAllByDepartmentAndCid(department).subscribe(
      (res: any) => {
        console.log('Department Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Department Error:', err);
      }
    );
  }

  getAllByType(type: any) {
    this.generic_service.getAllByType(type).subscribe(
      (res: any) => {
        console.log('Type Result:', res);
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectInfoList = []
          this.objectInfoListFilter = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Type Error:', err);
      }
    );
  }



  selectDelete(id:any,record: any){
    this.objectInfoId = id;
    this.recordId = record.objectInfoId;
    this.recordName = record.givenName;
  }

  closeDeleteModal(){
    this.recordId = "";
    this.recordName = "";
  }


  getAllObjectTemplate(){
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any)=>{
        this.objectTemplateList = response.response
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  remove(){
    document.getElementById("closeModalButton")?.click()
  }

  addObjectInfo(){
    console.log('Form Value:', this.addForm.value);
  }



  getObjectTemplateById(objectTemplateId: any){
    this.generic_service.getObjectTemplateById(objectTemplateId).subscribe(
      (response: any)=>{
        console.log(response.response)
        const data = response.response;

        this.singleObjectTemplateData = []
        this.singleObjectTemplateData.push(response.response)

        this.addForm.patchValue({
          serialNumberCheckBox: data.serialNumberCheckBox || false,
          branchCheckBox: data.branch || false,
          departmentCheckBox: data.department || false,
          locationCheckBox: data.location || false,
          makeCheckBox: data.make || false,
          modelCheckBox: data.model || false,
          originalCostCheckBox: data.originalCost || false,
          currentCostCheckBox: data.currentCost || false,
          depreciationCheckbox: data.depreciationRequired || false,
          icon: data.iconUrl || "",
          parentAssetIdFlag: data.parentAssetIdFlag || false,
          warranty: data.warranty || false,
          purchase: data.purchase || false,
          quantityCheckBox: data.quantityCheckBox || false,
          uom: data.uom || false,
          deploy: data.deploy || false,
          stockPointStatus: data.stockPointStatus || false
        });
        console.log('Form Value:', this.addForm.value);

      },
      (error: any)=>{
        console.log(error)
      }
    )
  }



  filterInputByType(event: KeyboardEvent, inputType: 'number' | 'onlyText' | 'allText'): boolean {
    const key = event.key;
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Always allow control keys (e.g., backspace, arrows, delete, tab, etc.)
    const controlKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Tab', 'Home', 'End'
    ];
    if (controlKeys.includes(key)) {
      return true;
    }

    if (key === 'Enter') {
      return true;
    }

    switch (inputType) {
      case 'number':
        // Allow digits only
        if (!/^\d$/.test(key)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'onlyText':
        // Allow letters and space (not as first character)
        if (!/^[a-zA-Z ]$/.test(key) || (key === ' ' && currentValue.length === 0)) {
          event.preventDefault();
          return false;
        }
        break;

      case 'allText':
        // Allow all characters, but disallow space as first character
        if (key === ' ' && currentValue.length === 0) {
          event.preventDefault();
          return false;
        }
        break;

      default:
        event.preventDefault();
        return false;
    }

    return true;
  }

  filterInputByType1(event: KeyboardEvent, inputType: 'number' | 'onlyText' | 'allText'): boolean {
  const key = event.key;
  const input = event.target as HTMLInputElement;
  const value = input.value;

  // Allow system shortcuts (Ctrl+C, Ctrl+V, Cmd+V, etc.)
  if (event.ctrlKey || event.metaKey) {
    return true;
  }

  // Always allow control/navigation keys
  const controlKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End', 'Enter'
  ];

  if (controlKeys.includes(key)) {
    return true;
  }

  switch (inputType) {
    case 'number':
      if (!/^\d$/.test(key)) {
        event.preventDefault();
        return false;
      }
      break;

    case 'onlyText':
      if (
        !/^[a-zA-Z ]$/.test(key) ||
        (key === ' ' && value.length === 0)
      ) {
        event.preventDefault();
        return false;
      }
      break;

    case 'allText':
      if (key === ' ' && value.length === 0) {
        event.preventDefault();
        return false;
      }
      break;

    default:
      event.preventDefault();
      return false;
  }

  return true;
}



filterInputByType2(
  event: KeyboardEvent,
  inputType: 'number' | 'onlyText' | 'allText'
): boolean {
  const key = event.key;
  const input = event.target as HTMLInputElement;
  const value = input.value;

  // Allow Ctrl / Cmd shortcuts
  if (event.ctrlKey || event.metaKey) {
    return true;
  }

  // Allow control keys
  const controlKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End', 'Enter'
  ];

  if (controlKeys.includes(key)) {
    return true;
  }

  // ❌ Disallow space if input is empty (for ALL types)
  if (key === ' ' && value.length === 0) {
    event.preventDefault();
    return false;
  }

  switch (inputType) {
    case 'number':
      if (!/^\d$/.test(key)) {
        event.preventDefault();
        return false;
      }
      break;

    case 'onlyText':
      // ✅ Letters and space (not as first char)
      if (!/^[a-zA-Z ]$/.test(key)) {
        event.preventDefault();
        return false;
      }
      break;

    case 'allText':
      // ✅ Any character except leading space
      break;

    default:
      event.preventDefault();
      return false;
  }

  return true;
}



}
